"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const http_1 = require("../http");
const postMonthlyVehicleExpenses = async ({ axios, vehicleId, year, month, expenses }) => {
    const { data } = await http_1.httpPost({
        axios,
        url: `vehicles/${vehicleId}/expenses/${year}/${month}`,
        data: expenses
    });
    return data;
};
exports.default = postMonthlyVehicleExpenses;
